import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yesNo', standalone: true })
export class YesNoPipe implements PipeTransform {
  private readonly YES = $localize`:@@common.yes:Yes`;
  private readonly NO = $localize`:@@common.no:No`;

  transform(value: boolean | null | undefined, fallback: string = '—'): string {
    if (value === true) {
      return this.YES;
    }
    if (value === false) {
      return this.NO;
    }
    return fallback; // for null/undefined
  }
}
